module.exports = __webpack_public_path__ + "img/3.2d3913b4.png";